import type { ChangeEventHandler } from 'react';

type CheckBoxType = {
	name: string;
	id: string;
	required?: boolean;
	label: string;
	onChange: ChangeEventHandler<HTMLInputElement>;
	htmlFor: string;
	ariaLabel: string;
	disabled?: boolean;
	className?: string;
	value: string;
	checked?: boolean;
};

export default function CheckBox(props: CheckBoxType) {
	const {
		name,
		id,
		value,
		required,
		label,
		htmlFor,
		onChange,
		ariaLabel,
		disabled = false,
		className = '',
		checked,
	} = props;

	const checkTypeModel = {
		id: id,
		name: name,
		value: value,
		required: required,
		onChange: onChange,
		'aria-label': ariaLabel,
		disabled: disabled,
		className: className,
		checked: checked,
	};
	return (
		<label className='relative flex cursor-pointer items-center rounded-full p-3'>
			<input
				{...checkTypeModel}
				type='checkbox'
				className="peer relative size-6 cursor-pointer appearance-none rounded-md border-2 border-minos-form-input-border-color transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:size-12 before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-full before:bg-minos-form-secondary-color before:opacity-0 before:transition-opacity before:content-[''] checked:border-minos-form-input-border-color checked:bg-minos-form-secondary-color checked:before:bg-minos-form-secondary-color hover:before:opacity-10"
			/>
			<span className='pointer-events-none absolute left-6 top-2/4 -translate-x-2/4 -translate-y-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100'>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					className='size-3'
					viewBox='0 0 20 20'
					fill='currentColor'
					stroke='currentColor'
					strokeWidth='1'
				>
					<path
						fillRule='evenodd'
						d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
						clipRule='evenodd'
					></path>
				</svg>
			</span>

			<label
				htmlFor={htmlFor}
				className='font-minos-form-font-family ml-4 mt-px inline-block cursor-pointer select-none text-base tablet:minos-form-content-font-style'
			>
				{label}
			</label>
		</label>
	);
}
